import { Base } from './base';

export type GenericCustomFieldValue = {
	Id?: number;
	GenericCustomFieldId: number;
	ObjectId: number;
	Value: string;
};

export interface GenericCustomField extends Base {
	DataType: GenericCustomFieldDataType;
	Order: number;
	IsMandatory: boolean;
	SystemName: string;
	ObjectType: GenericCustomFieldObjectType;
	Value: GenericCustomFieldValue | null;
}

export enum GenericCustomFieldDataType {
	Textbox = 1,
	Password = 2,
	Email = 3,
	Textarea = 4,
	Checkbox = 5,
	Checkboxlist = 6,
	Radiobutton = 7,
	Select = 8,
	TextboxNumber = 9,
}

export enum GenericCustomFieldObjectType {
	User = 1,
	Area = 2,
	Unit = 3,
	UnitType = 4,
	Event = 5,
}
